import type { FC } from 'react';

import { useGameConfig } from '../../config/GameConfigProvider';
import { useCoreDispatch } from '../../store/CoreStore';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { HeaderModal } from '../../store/slices/header/types';
import { Modal } from '../modal/modal';

import { QuickGuidePlain } from './QuickGuidePlain';

interface QuickGuideConnectedProps {}

export const QuickGuideModalConnected: FC<QuickGuideConnectedProps> = () => {
  const dispatch = useCoreDispatch();
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const { quickGuideContent } = useGameConfig();

  const handleClose = (): void => {
    dispatch(headerActions.setOpenedModal(null));
  };

  if (!quickGuideContent) return null;

  return (
    <Modal
      fullScreenNoClose
      draggable
      floating
      large
      open={openedModal === HeaderModal.QuickGuide}
      tk="QG_QUICK_GUIDE"
      onClose={handleClose}
    >
      <QuickGuidePlain
        isOpen={openedModal === HeaderModal.QuickGuide}
        listItems={quickGuideContent}
        onPlayAction={handleClose}
      />
    </Modal>
  );
};
